/* istanbul ignore file */
/**
 * Load an image element from a given src
 */
export const loadImage = (src: string, crossOrigin = ''): Promise<HTMLImageElement> =>
  new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = crossOrigin;
    img.addEventListener('load', () => resolve(img));
    img.src = src;
  });
